import ClauseTypeType from '../store/schema/ClauseTypeType';
import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';

export default action('setClauseType')(function setClauseType(
    clauseType: ClauseTypeType,
    clauseId: string
) {
    store.inboxRulesEditState.clauseMap.get(clauseId).clauseType = clauseType;
});
